/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const KeyIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="KeyIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M10.5 6.5C11.0523 6.5 11.5 6.05228 11.5 5.5C11.5 4.94772 11.0523 4.5 10.5 4.5C9.94772 4.5 9.5 4.94772 9.5 5.5C9.5 6.05228 9.94772 6.5 10.5 6.5Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 2C7.79086 2 6 3.79086 6 6C6 6.37784 6.05253 6.74424 6.15098 7.0919C6.15615 7.11016 6.15552 7.12547 6.15345 7.13468C6.15252 7.1388 6.15105 7.14184 6.15105 7.14184L3.29289 9.99998C3.10536 10.1875 3 10.4419 3 10.7071V12C3 12.5523 3.44772 13 4 13H6C6.55228 13 7 12.5523 7 12V11L7.99999 11C8.55228 11 9 10.5523 9 10L10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2ZM7 6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9H9C8.44771 9 8 9.44771 8 10L7.00001 9.99999C6.44772 9.99998 6 10.4477 6 11V12H4V10.7071L6.85855 7.84855C7.14462 7.56248 7.20917 7.15849 7.11314 6.81942C7.03955 6.55954 7 6.2848 7 6Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

KeyIcon.tags = ['key', 'lock', 'unlock', 'security', 'password', 'access'];

KeyIcon.category = 'General Icons';

KeyIcon.iconSize = 16;
